<template>
    <div>
        <breadcrumb :routerList="[{to:'/credit',title:'回款管理'},{title:'返利列表'}]"/>
        <div class="h-content">
            <div class="h-piece">
                <div class="">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称">
							    <el-input v-model="formInline.custname" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="月份筛选" style="width: 50%;">
								<el-date-picker
									placeholder="请选择"
									v-model="formInline.startdate"
									type="month"
									:clearable="false"
									value-format="yyyy-MM"
									@change="dateChange1" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
									placeholder="请选择"
									v-model="formInline.enddate"
									type="month"
									:clearable="false"
									value-format="yyyy-MM"
									 @change="dateChange2">
								</el-date-picker>
							</el-form-item>
							<el-form-item class="right-item">
								<el-button class="h-btn h-formBtn" @click="query">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="chongzhi">重置</el-button>
							</el-form-item>
						</div>	
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange"
                            :data="tableData"
                            stripe
							border
							max-height="500"
                            style="width: 100%"
                    >
                        <el-table-column
                                type="selection"
                                label="全选"
								width="40"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
								width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="serialnum"
                                label="流水号"
                                :show-overflow-tooltip="true"
                                width="130">
                        </el-table-column>
                        <el-table-column
                                prop="orgname"
                                label="工贸"
								min-width="180"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.orgname | dictname('kkber_value')}}
								</div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="custname"
                                label="客户名称"
								min-width="180"
								 :show-overflow-tooltip="true"
                               >
							   <template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.custname}}
									</div>
							   </template>
                        </el-table-column>
                        <el-table-column
                                prop="rewardname"
                                label="奖励名称"
								width="160"
								 :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="startdate"
                                label="开始日期"
                                width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.startdate?scope.row.startdate.substr(0,10):'' }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="enddate"
                                label="截止日期"
                                width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.enddate?scope.row.enddate.substr(0,10):'' }}</span>
                            </template>
                        </el-table-column>
                       <!-- <el-table-column
                                prop="issuedate"
                                label="下发日期"
								 :show-overflow-tooltip="true"
                                width="100">
                            <template slot-scope="scope">
                                <span>{{ scope.row.issuedate?scope.row.issuedate.substr(0,10):'' }}</span>
                            </template>
                        </el-table-column>-->
                       <!-- <el-table-column
                                prop="basecash"
                                label="基数">
                        </el-table-column>-->
                        <el-table-column
                                prop="cashable"
								width="90"
                                label="返利总额">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.cashable}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="cashed"
								width="90"
                                label="已返利">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.cashed}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="tocash"
								width="90"
                                label="剩余返利">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.tocash}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="iscancel"
								width="90"
                                label="是否作废">
                            <template slot-scope="scope">
                                <span>{{scope.row.iscancel | dictname('iscancel')}}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column
                                prop="iswriteoff"
                                label="是否核销">
                            <template slot-scope="scope">
                                <span>{{scope.row.iswriteoff | dictname('iswriteoff')}}</span>
                            </template>
                        </el-table-column>-->
                        <!--<el-table-column
                                label="操作" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="showdetail(scope.row.serialnum)">
                                    查看
                                </el-button>
                            </template>
                        </el-table-column>-->
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="formInline" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'

    export default {
        data() {
            return {
                tableData: [],
                formInline: {
                    custnameLike: '',
                    custname: '',
                    startdate: '',
                    enddate: '',
                    areaCode: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                multipleSelection: [],
            }
        },
        created() {
            this.query();
        },
        methods: {
            dateChange1(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day1 = date.getTime();
                if (this.day2 < this.day1) {
                    if (this.day2 == 0) {
                        return;
                    }
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.formInline.enddate = "";
                }
            },
            dateChange2(val) {
                val = val.replace(/-/g, '/')
                var date = new Date(val);
                this.day2 = date.getTime()
                if (this.day2 < this.day1) {
                    this.$msg.msge("结束日期不能在开始日期之前");
                    this.formInline.enddate = "";
                }
            },
            //检索
            query() {
                ss.Custcash.query(this.formInline).then(rd => {
                    this.formInline.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            showdetail(value) {
                this.$router.push({path: "/rebateDetail", query: {sid: value}});
            },
            chongzhi() {
                this.formInline.custname = '',
                    this.formInline.startdate = '',
                    this.formInline.enddate = ''
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/custcash/bscCustcashSum/downloadExcel", idlist, "post", 'data');
            }
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }

    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }

    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }

    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }

    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }

    .tip {
        margin-left: 1.6rem;
        color: #b0b0b0;
        font-size: 0.2rem;
        margin-top: 10px;
    }

    .h-bgccc {
        background: #edf5fa;
        border-color: #959595;
        color: #92999e;
    }
</style>
<style>
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }

    .selectorBox .el-upload-list {
        display: none;
    }
    /* .h-tableB.h-mrt30.left{
        margin-left: 20px;
    } */
    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }
    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .piliang1 {
        font-size: 18px;
        color: #303030;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliang2 {
        font-size: 16px;
        color: #919191;
        margin-top: 10px;
        margin-left: 10px;
    }
    .piliangBox {
        display: flex;
        margin-top: 20px;
        align-items: center;
        
        margin-bottom: 20px;
    }
    .piliangBox .imgs {
        font-size: 16px;
        color: #4b4b4b;
        margin-left: 10px;
        
    }
</style>